'use strict';

var DAGLink = require('./index.js');

function create(name, size, cid, callback) {
  var link = new DAGLink(name, size, cid);
  callback(null, link);
}

module.exports = create;